module.exports = __webpack_public_path__ + "img/film.43daceb8.svg";